export default __webpack_public_path__ + "static/media/tunnel2.b5dfb2d4.jpg";